// extracted by mini-css-extract-plugin
export default {"row":"row--aSlrhfNwZ1","name":"name--XxJtvn4FEr","items":"items--pLW+pKD8EA","row-button":"row-button--MQ+s7gSvc-","rowButton":"row-button--MQ+s7gSvc-"};